import React from "react"
import { useContext } from "react"
import store from "../store"

var context=React.createContext(-1)
export var StepIndexProvider=context.Provider
export function useStepIndex(){
  var ctx=useContext(context)
  if(ctx>=0){
    if(ctx>store.steps.length) {
      
    }
  } else if(ctx==-1) {
    // two sides. Old behaviour
    ctx=store.selectedStep
  }
  return ctx
}

